/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentStateField } from './ConversationalAgentStateField';
import {
  ConversationalAgentStateFieldFromJSON,
  ConversationalAgentStateFieldFromJSONTyped,
  ConversationalAgentStateFieldToJSON,
} from './ConversationalAgentStateField';

/**
 *
 * @export
 * @interface ConversationalAgentStateSchemaCreate
 */
export interface ConversationalAgentStateSchemaCreate {
  /**
   *
   * @type {Array<ConversationalAgentStateField>}
   * @memberof ConversationalAgentStateSchemaCreate
   */
  fields: Array<ConversationalAgentStateField>;
}

/**
 * Check if a given object implements the ConversationalAgentStateSchemaCreate interface.
 */
export function instanceOfConversationalAgentStateSchemaCreate(
  value: object,
): value is ConversationalAgentStateSchemaCreate {
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function ConversationalAgentStateSchemaCreateFromJSON(json: any): ConversationalAgentStateSchemaCreate {
  return ConversationalAgentStateSchemaCreateFromJSONTyped(json, false);
}

export function ConversationalAgentStateSchemaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentStateSchemaCreate {
  if (json == null) {
    return json;
  }
  return {
    fields: (json['fields'] as Array<any>).map(ConversationalAgentStateFieldFromJSON),
  };
}

export function ConversationalAgentStateSchemaCreateToJSON(value?: ConversationalAgentStateSchemaCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    fields: (value['fields'] as Array<any>).map(ConversationalAgentStateFieldToJSON),
  };
}
